import React from "react";
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { JOB_STATES_DISPLAY } from "utils/constants"
import { surveyorProductDisplay } from "utils/index"
import { getCurrentUser } from "../../../reducers"

const RelatedJobServiceItem = ({ jobService }) => {
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const {
    id,
    attributes: {
      label,
      code,
      jobId,
      bookedInForJobServiceId,
      state,
    }
  } = jobService

  const { label: displayLabel } = surveyorProductDisplay(code, label, systemRole, currentTeamRole)

  const onClickItem = link => {
    window.location.href = link
  }

  return (
    <tr className="border-top border-bottom" key={`related-jobService-${id}`}>
      <td>
        <Link
          to={`/jobs/${jobId}/job_services/${id}`}
          onClick={() => onClickItem(`/jobs/${jobId}/job_services/${id}`)}
          className="link-no-decoration">
          {displayLabel}
        </Link>
        { bookedInForJobServiceId && (
          <p className="text-muted mb-0">
            {bookedInForJobServiceId && "Linked Booked In Job"}
          </p>
        )}
      </td>
      <td>{JOB_STATES_DISPLAY[state]?.text}</td>
    </tr>
  )
}

export default RelatedJobServiceItem
